const EN = {
    title: 'Cards',
    table: {
        title: 'Card list',
        columns: {
            id: 'Internal ID',
            gpaccount: 'GP Account',
            created: 'Created',
            type: 'Type',
            lastFour: 'Last four',
            client: 'Client',
            status: 'Status',
            virtualCard: 'Virtual Card',
            identification: 'INE'
        },
        status: {
            title: 'Status',
            1: 'Normal',
            2: 'Inactive',
            3: 'Reprint',
            4: 'Reported',
            5: 'Renovated',
            6: 'Blocked',
            7: 'Disabled',
            8: 'Reported IVR',
            9: 'Blocked IVR',
            10: 'Expired'
        },
    },
    details: {
        inputs: {
            limit: 'Total limit',
            availableLimit: 'Available limit',
            closingDate: 'Closing date',
            dueDate: 'Due date',
            nextClosingDate: 'Next closing date',
            nextDueDate: 'Next due date',
            pendingPayment: 'Pending payment'
        }
    },
    payment: {
        title: 'Report payment',
        description: 'Card last number: ',
        amount: 'Amount',
        success: {
            title: 'Payment reported',
            description: 'The payment report has been successfully made.'
        },
        fail: {
            title: 'Payment failed',
            description: 'The payment report has failed.'
        }
    }
};

export default EN;
